(function(document) {

    var selectors = {
      cartPopup: '.cart-popup',
      cartPopupMobile: '.cart-popup-mobile',
      cartFormDesktop: '.cart-popup form.cart',
      cartFormMobile: '.cart-popup-mobile form.cart',
      cartActionLess: '.cart-action-oneless',
      cartActionMore: '.cart-action-onemore',
      cartActionQuantity: '.cart-action-quantity',
      cartQtyInput: '.cart__qty-input',
      cartItemRemove: '.cart-item-title__remove',
      cartItemPrice: '.cart-item-info__option__price',
      cartItems: '.cart-item-single',
      cartCounts: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartSubtotals: '[data-cart-subtotal]',
      freeShipping: '[data-free-shipping]',
      freeShippingText: '[data-free-shipping-text]',
      freeShippingFill: '[data-free-shipping-fill]',
      crossSell: '[data-cart-cross-sell]',
      crossSellList: '[data-cart-cross-sell-list]',
      crossSellCard: '[data-cross-sell-card]',
      crossSellAdd: '[data-cross-sell-add]',
      crossSellToggle: '[data-cross-sell-toggle]',
      crossSellVariants: '.cart-cross-sell__variants',
      crossSellNav: '[data-cart-cross-sell-nav]',
      crossSellPrev: '[data-cross-sell-prev]',
      crossSellNext: '[data-cross-sell-next]',
      cartClose: '[data-cart-close]',
      headerCartBtn: '.site-header__cart',
    };

    var cartRequestCount = 0
    var crossSellRequestCount = 0
    var crossSellCache = {}
    var crossSellTimers = []

    addEventListener("load", function() {
      // il popup desktop esce dall'header (che ha un transform) per poter essere fixed sulla finestra
      let cartPopup = document.querySelector(selectors.cartPopup)
      if (cartPopup && cartPopup.parentElement !== document.body) document.body.appendChild(cartPopup)
      if (cartPopup) {
        new MutationObserver(positionCartPopup).observe(cartPopup, { attributes: true, attributeFilter: ["class"] })
        // l'header si sposta allo scroll con una transizione: si segue per qualche frame
        window.addEventListener("scroll", followHeader, { passive: true })
        window.addEventListener("resize", followHeader)
        let header = document.querySelector("header.site-header")
        if (header) header.addEventListener("transitionend", positionCartPopup)
      }
      // mobile: con il pannello (carrello o menu) aperto la pagina sotto non deve scorrere
      let mobileContainer = document.querySelector(".nav-mobile-container")
      if (mobileContainer) {
        new MutationObserver(function() { lockPageScroll(mobileContainer.classList.contains("open")) })
          .observe(mobileContainer, { attributes: true, attributeFilter: ["class"] })
      }
      init()
    })

    // Blocco dello scroll della pagina dietro al pannello mobile: body fixed (l'unico modo
    // affidabile anche su iOS) ricordando la posizione, che viene ripristinata alla chiusura.
    var lockedScrollY = 0
    function lockPageScroll(lock) {
      let body = document.body
      let locked = body.classList.contains("mobile-panel-open")
      if (lock && !locked) {
        lockedScrollY = window.scrollY
        body.style.top = -lockedScrollY + "px"
        body.classList.add("mobile-panel-open")
      } else if (!lock && locked) {
        body.classList.remove("mobile-panel-open")
        body.style.top = ""
        let html = document.documentElement
        let prev = html.style.scrollBehavior
        html.style.scrollBehavior = "auto"
        window.scrollTo(0, lockedScrollY)
        html.style.scrollBehavior = prev
      }
    }

    var followUntil = 0
    function followHeader() {
      followUntil = Date.now() + 800
      positionCartPopup()
      requestAnimationFrame(function tick() {
        positionCartPopup()
        if (Date.now() < followUntil) requestAnimationFrame(tick)
      })
    }

    // il pannello desktop sta attaccato sotto il pulsante carrello dell'header (che si muove allo scroll)
    function positionCartPopup() {
      let popup = document.querySelector(selectors.cartPopup)
      let button = document.querySelector(selectors.headerCartBtn)
      if (!popup || !button || !popup.classList.contains("open")) return
      let bar = button.closest(".site-header__icons-wrapper") || button
      let r = bar.getBoundingClientRect()
      popup.style.top = Math.round(r.bottom) - 2 + "px" // il bordo alto del pannello coincide con quello basso della barra
      popup.style.right = Math.max(0, Math.round(document.documentElement.clientWidth - r.right)) + "px"
      popup.style.width = Math.round(r.width) + "px"   // largo quanto la barra icone da cui si apre
    }

    // Il contenuto dei popup viene rigenerato dopo ogni aggiunta dal cross-sell,
    // quindi tutto ciò che dipende dal markup va (ri)agganciato qui.
    function init() {
      renderFreeShipping()
      bindCartItems()
      loadCrossSell()
    }

    function bindCartItems() {

      let cartItems = document.querySelectorAll(selectors.cartItems)
      let cartCounts = document.querySelectorAll(selectors.cartCounts)
      let cartSubtotals = document.querySelectorAll(selectors.cartSubtotals)

      cartItems.forEach( (cartItem) => {

        let cartActionLess = cartItem.querySelector(selectors.cartActionLess);
        let cartActionMore = cartItem.querySelector(selectors.cartActionMore);
        let cartActionQuantity = cartItem.querySelector(selectors.cartActionQuantity)
        let cartQtyInput = cartItem.querySelector(selectors.cartQtyInput)
        let cartItemRemove = cartItem.querySelector(selectors.cartItemRemove)
        let cartItemPrice = cartItem.querySelector(selectors.cartItemPrice)
        let cartItemLineIndex = cartItem.getAttribute("data-item-line")

        // cestino: rimozione asincrona e popup rigenerato (il link /cart/change resta come fallback senza JS)
        cartItemRemove.addEventListener("click", function(e){
          e.preventDefault()
          removeCartLine(cartItem, cartItemLineIndex)
        })

        cartActionLess.addEventListener("click", function(){
          let cartQnt = Number.parseInt(cartActionQuantity.innerHTML)
          cartQnt--
          if (cartQnt <= 0) {
            removeCartLine(cartItem, cartItemLineIndex)
            return
          }
          cartActionQuantity.innerHTML = cartQnt.toString()
          cartQtyInput.value = cartQnt
          cartCounts.forEach(cartCount => {
            let cartCountNumber = Number.parseInt(cartCount.innerHTML)
            cartCountNumber--
            cartCount.innerHTML = cartCountNumber
          })
          cartSubtotals.forEach(cartSubtotal => {
            let cartSubtotalClean = cartSubtotal.getAttribute("data-subtotal-clean")
            let cartSubtotalCurrency_symbol = cartSubtotal.getAttribute("data-subtotal-currency_symbol")
            let cartSubtotalCurrency_iso_code = cartSubtotal.getAttribute("data-subtotal-currency_iso_code")
            let cartSubtotalNumber = Number.parseInt(cartSubtotalClean)
            let cartItemPriceClean = cartItemPrice.getAttribute("data-price-clean")
            let cartItemPriceNumber = Number.parseInt(cartItemPriceClean)
            cartSubtotalNumber = cartSubtotalNumber - cartItemPriceNumber
            cartSubtotal.setAttribute("data-subtotal-clean", cartSubtotalNumber)
            cartSubtotal.innerHTML = cartSubtotalCurrency_symbol + " " + cartSubtotalNumber.toFixed(2) + " " + cartSubtotalCurrency_iso_code
          })

          updateCartAsync(cartItemLineIndex,cartQnt)

        })
        cartActionMore.addEventListener("click", function(){
          let cartQnt = Number.parseInt(cartActionQuantity.innerHTML)
          cartQnt++
          cartActionQuantity.innerHTML = cartQnt.toString()
          cartQtyInput.value = cartQnt
          cartCounts.forEach(cartCount => {
            let cartCountNumber = Number.parseInt(cartCount.innerHTML)
            cartCountNumber++
            cartCount.innerHTML = cartCountNumber
          })
          cartSubtotals.forEach(cartSubtotal => {
            let cartSubtotalClean = cartSubtotal.getAttribute("data-subtotal-clean")
            let cartSubtotalCurrency_symbol = cartSubtotal.getAttribute("data-subtotal-currency_symbol")
            let cartSubtotalCurrency_iso_code = cartSubtotal.getAttribute("data-subtotal-currency_iso_code")
            let cartSubtotalNumber = Number.parseInt(cartSubtotalClean)
            let cartItemPriceClean = cartItemPrice.getAttribute("data-price-clean")
            let cartItemPriceNumber = Number.parseInt(cartItemPriceClean)
            cartSubtotalNumber = cartSubtotalNumber + cartItemPriceNumber
            cartSubtotal.setAttribute("data-subtotal-clean", cartSubtotalNumber)
            cartSubtotal.innerHTML = cartSubtotalCurrency_symbol + " " + cartSubtotalNumber.toFixed(2) + " " + cartSubtotalCurrency_iso_code
          })

          updateCartAsync(cartItemLineIndex,cartQnt)

        })
      })

    }

    // Soglia spedizione gratuita: data-threshold è in centesimi nella valuta dello shop,
    // il totale del carrello è in centesimi nella valuta del cliente.
    function renderFreeShipping(cartTotal) {

      let currency = (window.Shopify && window.Shopify.currency) || {}

      document.querySelectorAll(selectors.freeShipping).forEach( (freeShipping) => {

        let threshold = Number.parseInt(freeShipping.getAttribute("data-threshold"))
        let total = cartTotal === undefined ? Number.parseInt(freeShipping.getAttribute("data-total")) : cartTotal

        if (currency.active && currency.active != freeShipping.getAttribute("data-shop-currency")) {
          // arrotonda per eccesso all'unità, così non si promette la spedizione gratuita troppo presto
          threshold = Math.ceil(threshold * Number.parseFloat(currency.rate) / 100) * 100
        }
        if (!(threshold > 0) || Number.isNaN(total)) {
          freeShipping.hidden = true
          return
        }

        let remaining = threshold - total
        let freeShippingText = freeShipping.querySelector(selectors.freeShippingText)
        let freeShippingFill = freeShipping.querySelector(selectors.freeShippingFill)

        if (remaining > 0) {
          freeShippingText.innerHTML = freeShipping.getAttribute("data-text-remaining").replace("[amount]", formatMoney(remaining, currency.active))
        } else {
          freeShippingText.innerHTML = freeShipping.getAttribute("data-text-reached")
        }
        if (freeShippingFill) {
          freeShippingFill.style.width = Math.max(0, Math.min(100, total * 100 / threshold)) + "%"
        }
        freeShipping.setAttribute("data-total", total)
        freeShipping.classList.toggle("is-reached", remaining <= 0)
        freeShipping.hidden = false
      })

    }

    function formatMoney(cents, currencyCode) {
      if (window.theme && theme.Currency && theme.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat)
      }
      return (cents / 100).toFixed(2) + " " + (currencyCode || "")
    }

    function updateCartAsync(cartItemLineIndex,cartQnt) {

      let cartRequest = ++cartRequestCount

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
             'Accept': 'application/json',
             'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'line': cartItemLineIndex,
          'quantity': cartQnt
          })
        })
        .then(response => response.json())
        .then(cart => {
          // con click ravvicinati conta solo la risposta dell'ultima richiesta
          if (cartRequest == cartRequestCount && typeof cart.total_price == "number") {
            renderFreeShipping(cart.total_price)
          }
        })
        .catch(() => {})

    }

    function removeCartLine(cartItem, cartItemLineIndex) {
      if (cartItem.classList.contains("is-removing")) return
      cartItem.classList.add("is-removing")
      cartRequestCount++
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'line': cartItemLineIndex, 'quantity': 0 })
      })
        .then(response => { if (!response.ok) throw new Error("remove failed"); return response.json() })
        .then(refreshCartPopup)
        .catch(() => { cartItem.classList.remove("is-removing") })
    }

    // ---- Cross-sell: correlati dei prodotti a carrello, mescolati ----

    function loadCrossSell() {

      let containers = document.querySelectorAll(selectors.crossSell)
      if (!containers.length) return
      let config = containers[0]

      let cartProductIds = []
      document.querySelectorAll(selectors.cartItems + '[data-product-id]').forEach(item => {
        let id = item.getAttribute("data-product-id")
        if (id && cartProductIds.indexOf(id) < 0) cartProductIds.push(id)
      })
      if (!cartProductIds.length) {
        containers.forEach(c => { c.hidden = true })
        return
      }

      let limit = Number.parseInt(config.getAttribute("data-limit")) || 4
      let maxSources = Number.parseInt(config.getAttribute("data-max-sources")) || 3
      // con più prodotti a carrello si pescano i correlati di alcuni, scelti a caso
      let sources = shuffle(cartProductIds.slice()).slice(0, maxSources)
      let request = ++crossSellRequestCount

      Promise.all(sources.map(id => fetchRelated(config.getAttribute("data-url"), id)))
        .then(lists => {
          if (request != crossSellRequestCount) return

          // round robin tra le liste (già mescolate): un mix dei correlati di ogni prodotto,
          // senza doppioni e senza prodotti già a carrello
          let picked = []
          let seen = {}
          lists = lists.map(list => shuffle(list.slice()))
          let progressed = true
          while (picked.length < limit && progressed) {
            progressed = false
            for (let i = 0; i < lists.length && picked.length < limit; i++) {
              while (lists[i].length) {
                let card = lists[i].shift()
                if (seen[card.id] || cartProductIds.indexOf(card.id) >= 0) continue
                seen[card.id] = true
                picked.push(card.html)
                progressed = true
                break
              }
            }
          }

          containers.forEach(container => {
            let list = container.querySelector(selectors.crossSellList)
            list.innerHTML = picked.join("")
            list.scrollLeft = 0
            let nav = container.querySelector(selectors.crossSellNav)
            if (nav) nav.hidden = picked.length < 2
            container.hidden = picked.length == 0
          })
          startCrossSellAutoplay()
        })
    }

    // scorre lo slider da solo ogni N secondi (Theme settings > Cart cross-sell);
    // in pausa con il mouse sopra, per qualche secondo dopo un'interazione manuale,
    // e quando il popup non è visibile
    function slideCrossSell(list, dir) {
      let step = list.clientWidth
      let max = list.scrollWidth - list.clientWidth
      let next = list.scrollLeft + dir * step
      if (next > max + 2) next = 0
      if (next < -2) next = max
      list.scrollTo({ left: next, behavior: "smooth" })
    }

    function startCrossSellAutoplay() {
      crossSellTimers.forEach(clearInterval)
      crossSellTimers = []
      document.querySelectorAll(selectors.crossSell).forEach(container => {
        let seconds = Number.parseInt(container.getAttribute("data-autoplay")) || 0
        let list = container.querySelector(selectors.crossSellList)
        if (!seconds || !list || list.querySelectorAll(selectors.crossSellCard).length < 2) return
        if (!list.dataset.autoplayBound) {
          list.dataset.autoplayBound = "1"
          list.addEventListener("mouseenter", () => { list.dataset.paused = "1" })
          list.addEventListener("mouseleave", () => { delete list.dataset.paused; list.dataset.pauseUntil = Date.now() + seconds * 1000 })
          let manual = () => { list.dataset.pauseUntil = Date.now() + seconds * 2000 }
          list.addEventListener("touchstart", manual, { passive: true })
          list.addEventListener("pointerdown", manual)
          container.addEventListener("click", manual)
        }
        crossSellTimers.push(setInterval(() => {
          if (document.hidden || container.hidden || list.dataset.paused) return
          if (list.dataset.pauseUntil && Date.now() < Number(list.dataset.pauseUntil)) return
          if (!list.clientWidth || list.getClientRects().length == 0) return   // popup chiuso
          if (list.querySelector(".is-choosing, .is-adding")) return          // sta scegliendo una taglia
          slideCrossSell(list, 1)
        }, seconds * 1000))
      })
    }

    function fetchRelated(baseUrl, productId) {
      if (!crossSellCache[productId]) {
        let url = baseUrl + '?section_id=cart-cross-sell&product_id=' + productId + '&limit=8&intent=related'
        crossSellCache[productId] = fetch(url)
          .then(response => response.ok ? response.text() : "")
          .then(html => {
            let doc = new DOMParser().parseFromString(html, "text/html")
            return Array.from(doc.querySelectorAll(selectors.crossSellCard)).map(card => ({
              id: card.getAttribute("data-product-id"),
              html: card.outerHTML
            }))
          })
          .catch(() => [])
      }
      return crossSellCache[productId]
    }

    function shuffle(list) {
      for (let i = list.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let tmp = list[i]; list[i] = list[j]; list[j] = tmp
      }
      return list
    }

    document.addEventListener("click", function(e) {
      // frecce dello slider related
      let arrow = e.target.closest(selectors.crossSellPrev + ", " + selectors.crossSellNext)
      if (arrow) {
        e.preventDefault()
        let list = arrow.closest(selectors.crossSell).querySelector(selectors.crossSellList)
        slideCrossSell(list, arrow.matches(selectors.crossSellNext) ? 1 : -1)
        return
      }
      // ADD su un prodotto con taglie: mostra le taglie al posto del bottone
      let toggle = e.target.closest(selectors.crossSellToggle)
      if (toggle) {
        e.preventDefault()
        let card = toggle.closest(selectors.crossSellCard)
        let variants = card && card.querySelector(selectors.crossSellVariants)
        if (variants) {
          toggle.hidden = true
          toggle.setAttribute("aria-expanded", "true")
          variants.hidden = false
          card.classList.add("is-choosing")
        }
        return
      }
    })

    // click su una taglia / "aggiungi" di una card: aggiunge e rigenera il popup
    document.addEventListener("click", function(e) {
      let button = e.target.closest(selectors.crossSellAdd)
      if (!button || button.disabled) return
      e.preventDefault()

      let card = button.closest(selectors.crossSellCard)
      let buttons = card ? card.querySelectorAll(selectors.crossSellAdd) : [button]
      buttons.forEach(b => { b.disabled = true })
      if (card) card.classList.add("is-adding")

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: Number.parseInt(button.getAttribute("data-cross-sell-add")), quantity: 1 })
      })
        .then(response => { if (!response.ok) throw new Error("add failed"); return response.json() })
        .then(refreshCartPopup)
        .catch(() => {
          buttons.forEach(b => { b.disabled = false })
          if (card) card.classList.remove("is-adding")
        })
    })

    // Rigenera il contenuto dei due popup (desktop e mobile) con la Section Rendering API,
    // senza ricaricare la pagina. Vengono sostituiti solo i form interni, così i wrapper
    // e i bottoni di apertura/chiusura gestiti da header.js restano validi.
    function refreshCartPopup() {
      return fetch(window.Shopify.routes.root + '?sections=header', { headers: { 'Accept': 'application/json' } })
        .then(response => response.json())
        .then(data => {
          let doc = new DOMParser().parseFromString(data.header || "", "text/html")

          ;[selectors.cartFormDesktop, selectors.cartFormMobile].forEach(selector => {
            let fresh = doc.querySelector(selector)
            let current = document.querySelector(selector)
            if (fresh && current) current.innerHTML = fresh.innerHTML
          })

          let freshCount = doc.querySelector(selectors.cartCounts)
          if (freshCount) {
            document.querySelectorAll(selectors.cartCounts).forEach(el => { el.innerHTML = freshCount.innerHTML })
            document.querySelectorAll(selectors.cartCountBubble).forEach(el => {
              el.classList.toggle("hide", Number.parseInt(freshCount.innerHTML) == 0)
            })
          }

          init()
        })
    }

})(document);
